import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'Components/Modal';
import { useSelector } from 'react-redux';
import { RUNWAY_TYPES } from 'Utils/horseRacesNameMapper';

const HorseRacingWeatherModal = props => {
  const { modalClose } = props;

  const hippodromesInfo = useSelector( state => state.horseRacing.hippodromesInfo );
  const selectedHippodromeId = useSelector(state => state.horseRacing.hippodromesInfo.selectedHippodromeId);

  const data = hippodromesInfo?.data?.find(e=>e.cardId === selectedHippodromeId) || {};

  return (
    <Modal
      onClose={ modalClose }
      title="Hava ve Pist Durumu"
    >
      <div className='weather-conteiner'>
        <p><h3>Hava</h3> : { `${data.weatherInfo?.weather ?? ' - '}°C | ${data.weatherInfo?.condition ?? ' - '}` }</p>
        <p><h3>Nem</h3> : { `%${data.weatherInfo?.humidity ?? ' - '}` }</p>
        {
          data?.runwayInfo?.map(hip => (
            <>
              <p><h3>{ RUNWAY_TYPES[hip?.RunwayTypeEnum] }</h3> : { hip?.condition ?? ' - ' }</p>
            </>
          ))
        }
      </div>
    </Modal>
  );
};

HorseRacingWeatherModal.propTypes = {
  message: PropTypes.string,
  modalClose: PropTypes.func,
};

export default HorseRacingWeatherModal;
